<template>
  <div>
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="userNameSearch">
        <div class="searchTxt">角色名称</div>
        <el-input
          placeholder="请输入角色名称"
          size="medium"
          v-model="queryRole.roleName"
          @change="getRole()"
          clearable
        >
        </el-input>
      </div>
    </div>

    <!-- 卡片区域 -->
    <el-card class="right-card">
      <!-- 增加角色按钮 -->
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="small"
        class="add-btn"
        plain
        @click="AddRoleDialogVisible = true"
      >
        新增
      </el-button>
      <!-- 角色信息表格区域 -->
      <el-table
        :data="roleList"
        :header-cell-style="{
          background: '#0395d9',
          color: '#505255',
          textAlign: 'center',
        }"
        :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
      >
        <el-table-column prop="roleName" label="角色名称" min-width="20%">
        </el-table-column>
        <el-table-column prop="powers" label="拥有权限">
          <template v-slot="authsSlot">
            <span v-for="(powerName, i) in authsSlot.row.powers" :key="i">
              {{ powerName.powerName }}；
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130">
          <template v-slot="slot">
            <el-tooltip
              class="item"
              effect="dark"
              content="修改"
              placement="bottom-start"
            >
              <el-button
                type="warning"
                size="small"
                circle
                icon="el-icon-edit"
                @click="openEditDialog(slot.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              content="删除"
              placement="bottom-start"
              effect="dark"
            >
              <el-button
                type="danger"
                size="small"
                circle
                icon="el-icon-delete"
                @click="deleteRole(slot.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryRole.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="queryRole.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </el-card>

    <!-- 添加角色信息对话框 -->
    <el-dialog
      title="新增角色"
      :visible.sync="AddRoleDialogVisible"
      width="50%"
      height="80%"
      :close-on-click-modal="false"
      @close="clearAddRoleDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="addRoleFormRef"
        :rules="AddRoleRules"
        :model="addRoleInfo"
        label-width="80px"
      >
        <el-form-item prop="roleName" label="角色名称">
          <el-input
            placeholder="请输入角色名称"
            v-model="addRoleInfo.roleName"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="auths" label="所属权限">
          <!-- <el-select
            v-model="addRoleInfo.rolePower"
            placeholder="请选择"
            ref="MySelect"
          > -->
          <!-- <el-option
              :key="DepInfo.departmentParentId"
              :label="checkDname"
              :value="DepInfo.departmentParentId"
              style="height: auto"
            >
            </el-option> -->
          <el-card class="box-card">
            <el-tree
              ref="treeRef"
              :data="PowerTree"
              :props="defaultTreesProps"
              :expand-on-click-node="false"
              :highlight-current="true"
              default-expand-all
              show-checkbox
              node-key="id"
            >
            </el-tree>
          </el-card>
          <!-- </el-select> -->
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddRoleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addRole()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改角色信息对话框 -->
    <el-dialog
      title="编辑角色"
      :visible.sync="EditRoleDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearAddRoleDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="addRoleFormRef"
        :rules="AddRoleRules"
        :model="editRoleInfo"
        label-width="80px"
      >
        <el-form-item prop="roleName" label="角色名称">
          <el-input
            placeholder="请输入角色名称"
            v-model="editRoleInfo.roleName"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="auths" label="所属权限">
          <el-card class="box-card">
            <el-tree
              ref="treeRef"
              :data="PowerTree"
              :props="defaultTreesProps"
              :expand-on-click-node="false"
              :highlight-current="true"
              default-expand-all
              show-checkbox
              node-key="id"
              :default-checked-keys="activeKeys"
            >
            </el-tree>
          </el-card>
          <!-- </el-select> -->
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="EditRoleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editRole()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 权限信息
      roleList: [],
      // 总数量
      total: 0,
      // 查询权限信息
      queryRole: {
        // 角色名称
        roleName: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10,
      },
      // 控制添加权限的显示与隐藏
      AddRoleDialogVisible: false,

      // 添加角色信息
      addRoleInfo: {
        // 角色名称
        roleName: "",
        //  角色权限
        powerArray: [],
      },
      // 树节点默认选中的id节点数组
      activeKeys: [],
      PowerTree: [],

      defaultTreesProps: {
        children: "powerVos",
        label: "name",
      },

      // 控制编辑角色对话框的显示和隐藏
      EditRoleDialogVisible: false,

      // 编辑角色信息
      editRoleInfo: {
        // 角色名称
        roleName: "",
        //  角色权限
        powerArray: [],
        // 角色id
        roleId: "",
      },
      // 添加角色验证规则
      AddRoleRules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
        rolePower: [{ trigger: "change" }],
      },
    };
  },
  mounted() {
    this.getRole();
    this.getPowerTree();
  },
  methods: {
    // 获取权限信息
    async getRole() {
      const { data: res } = await this.$axios.get(`${this.$api}/role/search`, {
        params: this.queryRole,
      });
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.roleList = res.data.rows;
      this.total = res.data.total;
    },
    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryRole.pageSize = size;
      this.getRole();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryRole.page = current;
      this.getRole();
    },

    // 关闭添加角色对话框时触发
    clearAddRoleDialogVisible() {
      this.$refs.addRoleFormRef.resetFields();
      this.$refs.addRoleFormRef.clearValidate();
      this.$refs.treeRef.setCheckedKeys([]);
      this.activeKeys = [];
      this.addRoleInfo.powerArray = [];
    },

    // 查询权限树状数据
    async getPowerTree() {
      // const { data: res } = await this.$axios.get("/role/getAuth");
      let value = sessionStorage.getItem("loginInfo"); //字符串或json串
      let json = window.JSON.parse(value); //json串转为js对象
      this.PowerTree = json.powerTypeVoList;

      // 如果子菜单为空，这主菜单也过滤掉
      let newPowerTree = this.PowerTree.filter((obj) => {
        // console.log("obj.powerVos", obj.powerVos);
        if (obj.powerVos.length > 0) {
          return true; // 如果powerVos为空，过滤掉这个对象
        }
      });
      this.PowerTree = newPowerTree;
    },

    // 新增角色
    addRole() {
      this.$refs.addRoleFormRef.validate(async (valid) => {
        if (!valid) return;
        const keys = this.$refs.treeRef.getCheckedKeys(); //返回目前被选中的节点的 key 所组成的数组
        // this.$refs.treeRef.getHalfCheckedKeys(), //则返回目前半选中的节点的 key 所组成的数组
        // this.$refs.treeRef.getCheckedKeys();
        this.addRoleInfo.powerArray = keys;
        const { data: res } = await this.$axios.post(`${this.$api}/role/add`, {
          roleName: this.addRoleInfo.roleName,
          powerArray: this.addRoleInfo.powerArray,
        });
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("新增角色成功");
        this.getRole();
        this.AddRoleDialogVisible = false;
      });
    },

    // 打开编辑对话框
    openEditDialog(data) {
      this.editRoleInfo.roleName = data.roleName;
      this.editRoleInfo.roleId = data.roleId;
      this.EditRoleDialogVisible = true;
      var list = [];
      for (var i = 0; i < data.powers.length; i++) {
        list.push(data.powers[i].powerCode);
      }
      // for (var item in data.auths) {
      //   list.push(item.id);
      // }
      this.activeKeys = list;

      // this.activeKeys = data.auths;
    },

    // 编辑角色信息
    async editRole() {
      this.$refs.addRoleFormRef.validate(async (valid) => {
        if (!valid) return;
        this.editRoleInfo.powerArray = this.$refs.treeRef.getCheckedKeys();
        const { data: res } = await this.$axios.put(
          `${this.$api}/role/modify/` + this.editRoleInfo.roleId,
          {
            roleName: this.editRoleInfo.roleName,
            powerArray: this.editRoleInfo.powerArray,
          }
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.EditRoleDialogVisible = false;
        this.$message.success("编辑角色成功");
        this.getRole();
      });
    },

    // 删除角色信息
    async deleteRole(value) {
      const confirmVal = await this.$confirm(
        "此操作将永久删除该角色, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.delete(
        `${this.$api}/role/delete/` + value.roleId
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }

      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryRole.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryRole.page === lastPage &&
        this.total % this.queryRole.pageSize === 1
      ) {
        this.queryRole.page--; //页码-1
      }

      this.$message.success("已成功删除该角色");
      this.getRole();
    },
  },
};
</script>


<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}

.box-card {
  height: 400px !important;
  overflow: auto;
  margin: 0;
}

// el-dialog高度自适应，内容超出时中间出现滚动条
.common-dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  .el-dialog {
    margin: 0 auto !important;
    position: relative;
    .el-dialog__header {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      width: 100%;
      height: 60px;
      z-index: 1;
    }
    .el-dialog__body {
      width: 100%;
      overflow: hidden;
      overflow-y: auto;
      max-height: 90vh; //最大高度为视口高度的90%
      padding-top: 80px;
      padding-bottom: 100px;
      z-index: 1;
    }
    .el-dialog__footer {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 80px;
      z-index: 1;
    }
  }
}

.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;
  // 用户名搜索区域
  .userNameSearch {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 30px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 150px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Main/SystemManagement/rightsManagement.vue